// ABOUTME: Progression modal that approves a Bol replenishment.
// ABOUTME: With Bol pickup turned on step 1 picks the shipping type (self/pickup) and step 2 the picking date, otherwise only the date is picked.
import { useTranslation } from "react-i18next";

import ProgressionModal from "../../../theme/ProgressionBuilder/ProgressionModal";
import ProgressionWrapper from "../../../theme/ProgressionBuilder/ProgressionWrapper";
import { useApproveBolreplenishmentMutation } from "../../../../newapi/webshop/bolreplenishmentSlice";
import { useGetSettingsQuery } from "../../../../newapi/global/generalApiSlice";

import SelectType from "./views/SelectType";
import PickDate from "./views/PickDate";

const MpApproveBolReplenishment = (props) => {
    const { t } = useTranslation();

    const { data: bolReplenishmentSettings, isLoading: settingsLoading } = useGetSettingsQuery("bol_replenishment");
    // Without Bol pickup, delivering yourself is the only way to send an LvB, so the type step is left out
    const pickupEnabled = bolReplenishmentSettings?.find(setting => setting.key === "bol_replenishment_pickup_enabled")?.value === "true";

    const onSave = () => {
        props.handleClose();
    };

    return (
        <ProgressionModal
            open={props.open}
            onClose={props.handleClose}
        >
            {/* The first step becomes active on mount, so the steps wait until it is known which one comes first */}
            {!settingsLoading && (
                <ProgressionWrapper
                    onSave={onSave}
                    isModal
                    title={t("approve_bol_replenishment")}
                    query={useApproveBolreplenishmentMutation}
                >
                    {pickupEnabled && <SelectType bolReplenishmentId={props.data?.id} />}
                    <PickDate
                        customerDeliveryDate={props.data?.plannedShipmentDate}
                        onlyStep={!pickupEnabled}
                        bolReplenishmentId={props.data?.id}
                    />
                </ProgressionWrapper>
            )}
        </ProgressionModal>
    );
};

export default MpApproveBolReplenishment;
